<template>
    <div>
        <v-form model="valid" ref="form">
            <v-layout column>
                <v-flex>
                    <v-autocomplete v-model="location" :rules="locationRules" :items="possibleLocations" item-text="name"
                        item-value="id" label="Location" clearable required class="required" return-object>
                    </v-autocomplete>
                </v-flex>

                <v-flex v-if="positionStepReady">
                    <v-layout row>
                        <v-autocomplete v-model="position" :rules="positionRules" :items="possiblePositions"
                            item-text="name" item-value="id" label="Position" required class="required mr-2" return-object>
                        </v-autocomplete>
                        <v-checkbox v-if="position && position.name == 'CVT'" style="display: inline-block"
                            label="Allow New Grads" v-model="allowNewGrads">
                        </v-checkbox>
                        <div
                            v-if="position && position.name == 'Assistant'"
                            style="display: inline-block; padding-right: 3em;"
                        >
                            <v-checkbox label="Require Advanced Assistant" v-model="requireAdvancedAssistants">
                            </v-checkbox>
                            <div
                                v-if="requireAdvancedAssistants"
                                style="width: 220px; display: inline-block"
                            >
                                <small>
                                    (This employee is not a technician, but can place catheters,
                                    draw blood and administer pre-dosed medications.
                                    They cannot run anesthesia or perform dentals.)
                                </small>
                            </div>
                        </div>
                        <v-text-field label="Number of shifts" v-model="shiftCount"> </v-text-field>
                    </v-layout>
                </v-flex>

                <v-flex v-if="datesStepReady">
                    <div v-for="s in shiftDates" :key="s.uid">
                        <v-layout row>
                            <v-flex grow>
                                <ShiftScheduleSelector :start="s.start" :end="s.end"
                                    @updateStart="updateShiftStart($event, s.uid)"
                                    @updateEnd="updateShiftEnd($event, s.uid)" :rules="sunsetRulesError(s)" />
                                <div class="red--text" v-html="sunsetRulesError(s)"></div>
                            </v-flex>
                            <v-flex shrink>
                                <v-btn color=" error" @click="removeSchedule(s)" icon>
                                    <v-icon> delete </v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                    <v-btn color="primary" @click="addSchedule">
                        <span v-if="shiftDates.length === 0"> Add Schedule </span>
                        <span v-else> Add Another Schedule </span>
                    </v-btn>
                </v-flex>

                <!--
        <v-flex>
          other details
        </v-flex>
        -->
                <v-flex v-if="shiftDates.length > 0">
                    <v-checkbox label="Advanced Options" v-model="showAdvanced"></v-checkbox>
                    <v-container fluid>
                        <v-layout>
                            <div v-if="showAdvanced" class="mb-4">
                                <v-layout row>
                                    <v-flex>
                                        <v-text-field class="straight-bonus-field" label="Bonus?" prefix="$"
                                            v-model="straightBonusAmount"
                                            hint="the Assigned Employee receives 2/3 of the total bonus offered.">
                                        </v-text-field>
                                    </v-flex>
                                    <v-layout row>
                                        <v-flex v-if="user.managerOrHigher" class="ml-2">
                                            <v-text-field label="Call In Bonus?"
                                                :hint="hasCoverBonus ? 'Not billed to client' : ''" persistent-hint
                                                prefix="$" v-model="callInBonusAmount">
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex v-if="user.managerOrHigher">
                                            <v-switch label="Cover Bonus" v-model="hasCoverBonus"></v-switch>
                                        </v-flex>
                                    </v-layout>
                                    <v-flex v-if="user.managerOrHigher" class="ml-2">
                                        <v-text-field label="Travel Bonus?" prefix="$" v-model="travelBonusAmount">
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-layout column>
                                    <v-checkbox label="Limit to skills" v-model="limitedToSkills"> </v-checkbox>
                                    <v-layout v-if="limitedToSkills || skillsSelected.length > 0" row wrap
                                        jusitify-space-around>
                                        <v-flex xs4 v-for="skill in possibleSkills" :key="skill.id">
                                            <v-checkbox :label="skill.name" :value="skill.id"
                                                v-model="skillsSelected"></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-layout>

                                <v-divider class="my-4"></v-divider>

                                <v-layout row>
                                    <v-flex>
                                        <v-textarea box label="Details" v-model="details"> </v-textarea>
                                    </v-flex>
                                </v-layout>

                                <v-layout row>
                                    <v-flex shrink>
                                        <v-checkbox label="Sunset" hint="Cancel this shift if not filled by time chosen"
                                            persistent-hint v-model="sunsetOn"></v-checkbox>
                                    </v-flex>
                                    <v-flex>
                                        <v-select label="Cancel Shift" :items="sunsetAfterDayRange"
                                            v-model="sunsetAfterDays" style="display: inline-block"></v-select>

                                        <span v-if="sunsetOn && sunsetAfterDays"> days from start of shift </span>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-layout>
                    </v-container>
                </v-flex>
                <div v-if="minimumOptionsSet && !anySunsetErrors()">
                    <v-layout column>
                        <v-flex class="text-xs-right">
                            <v-dialog v-model="confirming" max-width="400">
                                <v-btn slot="activator" color="success">
                                    Create {{ totalShiftCount }} shift{{ totalShiftCount > 1 ? "s" : "" }}
                                </v-btn>
                                <v-card>
                                    <v-card-text>
                                        <h2 class="headline">Confirm Bulk Request</h2>
                                        <div class="mt-4" v-html="createSummary"></div>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="grey" flat small @click="confirming = false">Nevermind</v-btn>
                                        <v-btn color="success" small @click="bulkRequestShifts"> Yes, Request </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-flex>
                    </v-layout>
                </div>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ShiftScheduleSelector from "@/components/service/shift-schedule-selector.vue";
import { range } from "lodash";

export default {
    data() {
        return {
            valid: false,
            location: null,
            locationRules: [(v) => !!v || "Location is required"],
            position: null,
            positionRules: [(v) => !!v || "Position is required"],
            shiftCount: 1,
            allowNewGrads: false,
            requireAdvancedAssistants: false,
            shiftDates: [],
            confirming: false,
            straightBonusAmount: null,
            callInBonusAmount: null,
            travelBonusAmount: null,
            hasCoverBonus: false,
            repeats: false,
            repetitionOptions: [],
            repeatFrequency: null,
            repeatDuration: null,
            repeatDurationPicker: false,
            limitedToSkills: false,
            skillsSelected: [],
            possibleSkills: [],
            details: null,
            showAdvanced: false,
            sunsetOn: false,
            sunsetAfterDays: null,
            sunsetAfterDayRange: range(3, 31),
        };
    },

    created() {
        this.$store.dispatch("serviceRequest/getOptions", this.user.id);
        this.$store.dispatch("serviceRequest/getSkills").then((res) => {
            this.possibleSkills = res;
        });
    },
    watch: {
        sunsetOn(val) {
            if (!val) {
                this.sunsetAfterDays = null;
                this.sunsetDate = null;
            } else {
                this.sunsetAfterDays = 3;
            }
        },
    },
    computed: {
        ...mapState("userAuth", ["user"]),
        ...mapState("serviceRequest", ["possibleLocations", "possiblePositions", "assignableEmployees", "newRequestPreferences"]),

        positionStepReady() {
            if (this.location) {
                return true;
            }
            return false;
        },

        datesStepReady() {
            if (this.location && this.position) {
                return true;
            }
            return false;
        },

        minimumOptionsSet() {
            return this.location && this.position && this.shiftDates.length > 0;
        },

        totalShiftCount() {
            return this.shiftDates.length * this.shiftCount;
        },

        createSummary() {
            if (this.shiftCount === 0) {
                return "";
            } else {
                const shiftSummaries = this.shiftDates.map((s) => {
                    let canceledString = "";
                    if (this.sunsetOn) {
                        let shiftStartDate = new Date(s.start);
                        let sunsetDate = new Date(s.start);
                        sunsetDate.setDate(shiftStartDate.getDate() - this.sunsetAfterDays);
                        canceledString = `<li>Cancelled: ${this.$moment(sunsetDate).format("ddd, MMM DD YYYY, h:mma")}</li>`;
                    }

                    return `
            <li>${this.shiftCount} ${this.position.name} shift${this.shiftCount > 1 ? "s" : ""}<ul><li>Start: ${this.$moment(s.start).format("ddd, MMM DD YYYY, h:mma")}</li><li>End: ${this.$moment(s.end).format("ddd, MMM DD YYYY, h:mma")}</li>${canceledString}</ul></li>
          `;
                });
                return `Will request <strong>${this.totalShiftCount}</strong> total shifts at ${this.location.name}.<br/>
          <ul>
            ${shiftSummaries.join("")}
          </ul>
        `;
            }
        },
    },

    methods: {
        addSchedule() {
            const scheduleStruct = {
                uid: Date.now(),
                start: null,
                end: null,
                valid: false,
            };
            this.shiftDates.push(scheduleStruct);
        },

        bulkRequestShifts() {
            const count = this.shiftCount;
            const range = Array.from({ length: count }, (_, i) => i);
            let shiftStartDate;
            let sunsetDate = null;
            const shiftParams = this.shiftDates.flatMap((s) => {
                // Create as many copies of this as shiftCount
                return range.map((i) => {
                    if (this.sunsetOn) {
                        shiftStartDate = new Date(s.start);
                        sunsetDate = new Date(s.start);
                        sunsetDate.setDate(shiftStartDate.getDate() - this.sunsetAfterDays);
                    }

                    return {
                        details: this.details,
                        created_by_user_id: this.user.id,
                        employee_position_id: this.position.id,
                        new_grads_allowed: this.allowNewGrads,
                        advanced_assistants_required: this.requireAdvancedAssistants,
                        worksite_id: this.location.id,
                        start_datetime: s.start,
                        end_datetime: s.end,
                        straight_bonus_amount: this.straightBonusAmount,
                        call_in_bonus_amount: this.callInBonusAmount,
                        travel_bonus_amount: this.travelBonusAmount,
                        has_cover_bonus: this.hasCoverBonus,
                        // user_id: params.assignedUserId,
                        repeats: this.repeats,
                        repeat_frequency: this.repeatFrequency,
                        repeat_until: this.repeatDuration,
                        required_skill_ids: this.skillsSelected,
                        sunset_after: sunsetDate,
                    };
                });
            });

            this.$store.dispatch("serviceRequest/bulkCreate", shiftParams).then((r) => {
                this.confirming = false;
                this.$router.push({ name: "calendar" });
            });
        },

        removeSchedule(schedule) {
            this.shiftDates = this.shiftDates.filter((s) => s.uid !== schedule.uid);
        },

        updateShiftStart(time, uid) {
            const s = this.shiftDates.find((s) => s.uid === uid);
            s.start = time;
        },

        updateShiftEnd(time, uid) {
            const s = this.shiftDates.find((s) => s.uid === uid);
            s.end = time;
        },
        sunsetRulesError(shift) {
            if (this.sunsetOn) {
                let shiftStartDate = new Date(shift.start);
                let sunsetDate = new Date(shiftStartDate);
                sunsetDate.setDate(shiftStartDate.getDate() - this.sunsetAfterDays);
                this.sunsetDate = sunsetDate;

                let today = new Date();
                let daysBetween = 0;
                while (today < shiftStartDate) {
                    daysBetween++;
                    today.setDate(today.getDate() + 1);
                }
                if (daysBetween < 7) {
                    return "In order to sunset, shift start date must be at least 7 days out from shift request date.";
                }


                today = new Date();
                if (sunsetDate < today) {
                    return "Sunset date must be in the future.";
                }

                today = new Date();
                daysBetween = 0;
                while (today < sunsetDate) {
                    daysBetween++;
                    today.setDate(today.getDate() + 1);
                }
                if (daysBetween < 3) {
                    return "In order to sunset, sunset date must be at least 72 hours out from shift request date.";
                }
            }

            // no errors
            return "";
        },
        anySunsetErrors() {
            return this.shiftDates.some((s) => this.sunsetRulesError(s) !== "");
        },
    },

    components: {
        ShiftScheduleSelector,
    },
};
</script>
</script>
